/**
 * External-access request headers: the per-tab session token and the capability token taken from the
 * /external/{token} page URL.
 *
 * These are ONLY attached to same-origin requests. A cross-origin target (e.g. the presigned S3/GCS
 * upload URL that FileUpload posts to) gets nothing, so the grant token can never leak to a storage
 * or CDN host — a leaked X-External-Token is equivalent to the grant itself.
 *
 * @param {string} [targetUrl] the request's target (absolute or relative). Omitted/relative == same-origin.
 * @returns {Record<string, string>}
 */
export function externalAccessHeaders(targetUrl) {
    if (!isSameOrigin(targetUrl)) {
        return {};
    }

    const headers = {};

    const tabToken = sessionStorage.getItem('external_tab_token');
    if (tabToken) {
        headers['X-External-Tab-Token'] = tabToken;
    }

    // Bind the request to the tab's originating external access token (from the URL), so a grant
    // resolves per-tab rather than from the shared session value across tabs.
    const tokenInPath = window.location.pathname.match(/^\/external\/([^/]+)/);
    if (tokenInPath) {
        headers['X-External-Token'] = tokenInPath[1];
    }

    return headers;
}

function isSameOrigin(targetUrl) {
    if (!targetUrl) {
        return true; // relative/empty URLs resolve against the current origin
    }

    try {
        return new URL(targetUrl, window.location.origin).origin === window.location.origin;
    } catch {
        return false; // unparseable → fail closed, don't attach
    }
}
